import { Badge } from "@/components/ui/badge";
import { PERIOD_STATUS, SIZE_LABELS } from "@/lib/strings";
import { useI18n } from "@/context/I18nContext";

const STATUS_STYLES = {
  DRAFT: "bg-slate-100 text-slate-700 border-slate-300",
  IN_PROGRESS: "bg-sky-100 text-sky-800 border-sky-300",
  IN_REVIEW: "bg-amber-100 text-amber-800 border-amber-300",
  APPROVED: "bg-green-100 text-green-800 border-green-300",
  LOCKED: "bg-red-100 text-red-800 border-red-300",
};

export function PeriodStatusBadge({ status }) {
  const { t } = useI18n();
  const meta = PERIOD_STATUS[status] || { label: status };
  return (
    <Badge
      variant="outline"
      className={`${STATUS_STYLES[status] || ""} font-medium`}
      data-testid={`period-status-badge-${(status || "").toLowerCase()}`}
    >
      {t(`periodStatus.${status}`) || meta.label} ({status})
    </Badge>
  );
}

export function DemoBadge() {
  return (
    <Badge variant="outline" className="bg-amber-50 text-amber-800 border-amber-300 font-semibold" data-testid="demo-badge">
      DEMO
    </Badge>
  );
}

export function NoDataBadge() {
  const { t } = useI18n();
  return (
    <Badge variant="outline" className="bg-slate-50 text-slate-600 border-slate-300" data-testid="no-data-badge">
      {t("common.noData")}
    </Badge>
  );
}

export function SizeBadge({ size }) {
  if (!size) return <NoDataBadge />;
  return (
    <Badge variant="outline" className="bg-green-50 text-green-800 border-green-300 font-semibold" data-testid="company-sme-size-badge">
      {SIZE_LABELS[size] || size} ({size})
    </Badge>
  );
}
